// jQuery( document ).ready(function() {
//     if (objects.is_single) {
//         let url = window.location.href
//         let string = "Actualités"
//         if(url.includes("/wordpress/")){
//             url = window.location.origin + '/wordpress/actualite/'
//             if(objects.is_formation){
//                 url = window.location.origin + '/wordpress/categories/' + document.querySelector(".passUrl").innerHTML + '/'
//                 string = document.querySelector(".passString").innerHTML
//             }
//         } else {
//             url = window.location.origin + '/actualite/'
//             if(objects.is_formation){
//                 url = window.location.origin + '/categories/' + document.querySelector(".passUrl").innerHTML + '/'
//                 string = document.querySelector(".passString").innerHTML
//             }
//         }
//         document.querySelector(".breadcrumb_last").innerHTML = '<a href="' + url + '">' + string + '</a>'
//     }
// })